<template>
  <div class="ctn">
    <div class="relative z-20 text-white pb-3">
      <div class="logo-wrapper" :class="{'lns-logo-dark' : selectedColorPallet === 'dark'}">
        <lottie :options="lenossaAnimOptions" @animCreated="prepareAnimation" />
      </div>
      <div class="content-ctn container">
        <section>
          <h3 class="title my-5">
            A primeira boa impressão
          </h3>
          <div class="flex flex-col lg:flex-row">
            <div class="text-xl leading-tight lg:w-1/2">
              <p>
                Lenossa é uma empresa que utiliza da tecnologia para a criação de produtos. Durante o brainstorm para concepção da marca, chegamos a dois traços principais que gostaríamos de transmitir com ela: amigabilidade e modularidade.
              </p>
              <p class="mt-3">
                Adicionalmente, optou-se por uma identidade para a marca que não remetesse diretamente a modernidade e tecnologia. Pensamos: por que não?
              </p>
            </div>
            <div class="lg:w-1/2">
              <lenossa-pieces class="mt-3 lg:mt-4 lg:ml-3 xl:ml-5" :selected-color-pallet="selectedColorPallet" />
            </div>
          </div>
        </section>
        <section class="mt-8">
          <h3 class="title mb-5">
            Os pequenos pedaços do todo
          </h3>
          <div class="text-center">
            <img class="lg:h-128" src="@/assets/lenossa/lenossa-pieces-image.svg" alt="">
          </div>
        </section>
        <section class="mt-8">
          <h3 class="title mb-5">
            Cores
          </h3>
          <div v-observe-visibility="toggleColorPalletAutoChange" class="pallet-ctn">
            <div class="pallet pallet--light"
                 :class="{ 'pallet--active' : selectedColorPallet === 'dark' }"
                 @click="toggleColorPallet(true)"
                 @mouseenter="$store.dispatch($CHANGE_CURSOR_STATE, 'pointer')"
                 @mouseleave="$store.dispatch($CHANGE_CURSOR_STATE, 'default')"
            >
              <span id="tap-indicator-light" class="tap-indicator tap-indicator--light" />
              <div class="pallet__color" />
              <div class="pallet__color" />
              <div class="pallet__color" />
              <div class="pallet__color" />
              <span class="pallet__label">
                Light
              </span>
            </div>
            <div class="pallet pallet--dark"
                 :class="{ 'pallet--active' : selectedColorPallet === 'light' }"
                 @click="toggleColorPallet(true)"
                 @mouseenter="$store.dispatch($CHANGE_CURSOR_STATE, 'pointer')"
                 @mouseleave="$store.dispatch($CHANGE_CURSOR_STATE, 'default')"
            >
              <span id="tap-indicator-dark" class="tap-indicator tap-indicator--dark" />
              <div class="pallet__color" />
              <div class="pallet__color" />
              <div class="pallet__color" />
              <div class="pallet__color" />
              <span class="pallet__label">
                Dark
              </span>
            </div>
          </div>
          <div class="lns-brand-ctn lns--light">
            <div class="brand-ctn-divider" />
            <img class="logo" src="@/assets/lenossa/logo-light.svg" alt="">
            <img class="logo" :class="[selectedColorPallet === 'dark' ? 'opacity-100' : 'opacity-0']" src="@/assets/lenossa/logo-dark.svg" alt="">
            <div id="lns-light-bg" class="lns-color--bg lns-color lns--light">
              <span>
                #009CB0
              </span>
            </div>
            <div id="lns-light-brand" class="lns-color--brand lns-color lns--light">
              <span>
                #FFD443
              </span>
            </div>
            <div id="lns-dark-bg" class="lns-color--bg lns-color lns--dark">
              <span>
                #1F2D3C
              </span>
            </div>
            <div id="lns-dark-brand" class="lns-color--brand lns-color lns--dark">
              <span>
                #F4E2B0
              </span>
            </div>
          </div>
        </section>
        <div class="lns-footer">
          <div id="lns-light-footer-left" class="lns-color lns-color--footer-left lns--light">
            <span>#CC2A34</span>
          </div>
          <div id="lns-light-footer-right" class="lns-color lns-color--footer-right lns--light">
            <span>#E75F37</span>
          </div>
          <div id="lns-dark-footer-left" class="lns-color lns-color--footer-left lns--dark">
            <span>
              #608D66
            </span>
          </div>
          <div id="lns-dark-footer-right" class="lns-color lns-color--footer-right lns--dark">
            <span>#DE2034</span>
          </div>
          <div class="lns-footer__left lns--light" />
          <div class="lns-footer__right lns--light" />
          <div class="lns-footer__left lns--dark" :class="{'visible' : selectedColorPallet === 'dark'}" />
          <div class="lns-footer__right lns--dark" :class="{'visible' : selectedColorPallet === 'dark'}" />
        </div>
        <section class="photos-section">
          <img class="photo" src="@/assets/lenossa/smartphone.png" alt="">
          <img class="photo mt-6" src="@/assets/lenossa/business-card.png" alt="">
          <img class="photo mt-6" src="@/assets/lenossa/identity.png" alt="">
        </section>
      </div>
      <footer class="footer-page-ctn">
        <div class="footer-btns-ctn">
          <div class="lns-btn lns-btn--left">
            <button class="lns-btn__body sm-l:mr-3 md:mr-5"
                    @click="goTo('portfolio')"
                    @mouseenter="$store.dispatch($CHANGE_CURSOR_STATE, 'pointer')"
                    @mouseleave="$store.dispatch($CHANGE_CURSOR_STATE, 'default')"
            >
              Voltar ao Portfólio
            </button>
            <i class="lns-btn__icon fas fa-arrow-left" />
          </div>
          <div class="lns-btn lns-btn--right mt-3 sm-l:mt-0 md:mt-0">
            <a href="https://www.behance.net/gallery/62070681/Lenossa-brand-identity" target="_blank">
              <button class="lns-btn__body"
                      @mouseenter="$store.dispatch($CHANGE_CURSOR_STATE, 'pointer')"
                      @mouseleave="$store.dispatch($CHANGE_CURSOR_STATE, 'default')"
              >
                Ver Projeto no Behance
              </button>
              <i class="lns-btn__icon fab fa-behance-square" />
            </a>
          </div>
        </div>
        <div class="lns-page-footer">
          <div v-if="selectedColorPallet === 'light'"
               class="lns-page-footer__img lns-page-footer__img--light"
          />
          <div v-else
               class="lns-page-footer__img lns-page-footer__img--dark"
          />
        </div>
      </footer>
    </div>
    <div class="page-lns-dark-bg" :class="[selectedColorPallet === 'dark' ? 'opacity-100' : 'opacity-0']" />
    <div class="page-lns-light-bg" />
  </div>
</template>

<script>
import Lottie from 'vue-lottie'
import { TimelineMax, TweenMax, Power3, Power4 } from 'gsap'
import LenossaPieces from '@/components/lenossa-pieces'
import * as lenossaAnim from '@/assets/lenossa/lenossa-anim-data'
import * as lightThemeAnim from '@/assets/lenossa/lenossa-light-theme'
import * as darkThemeAnim from '@/assets/lenossa/lenossa-dark-theme'

export default {
  name: 'Lenossa',
  components: {
    Lottie,
    LenossaPieces
  },
  data () {
    return {
      lenossaAnim: null,
      lightAnim: null,
      darkAnim: null,
      lenossaAnimOptions: {
        animationData: lenossaAnim.default,
        autoplay: false,
        loop: false,
        animationSpeed: 1
      },
      palletChangeInterval: undefined,
      isPalletContainerVisible: false,
      didPalletChangeFirstTime: false,
      lightPalletTl: null,
      darkPalletTl: null,
      selectedColorPallet: 'light',
      lightThemeOptions: {
        animationData: lightThemeAnim,
        loop: false
      },
      darkThemeOptions: {
        autoplay: false,
        animationData: darkThemeAnim,
        loop: false
      },
      lightColorsTl: null,
      darkColorsTl: null
    }
  },
  methods: {
    toggleColorPalletAutoChange (isPalletContainerVisible) {
      if (isPalletContainerVisible) this.didPalletChangeFirstTime = true
      this.isPalletContainerVisible = isPalletContainerVisible
    },
    toggleColorPallet (disableAutoChange) {
      if (disableAutoChange) clearInterval(this.palletChangeInterval)
      if (this.selectedColorPallet === 'light') {
        this.selectedColorPallet = 'dark'
        setTimeout(() => {
          this.darkColorsTl.play()
        }, 250)
        this.lightColorsTl.reversed(true)
        this.lightColorsTl.reverse()
      } else {
        this.selectedColorPallet = 'light'
        setTimeout(() => {
          this.lightColorsTl.play()
        }, 250)
        this.darkColorsTl.reversed(true)
        this.darkColorsTl.reverse()
      }
    },
    prepareAnimation (anim) {
      this.lenossaAnim = anim
    },
    goTo (name) {
      if (this.$store.state.isMobile) {
        setTimeout(() => {
          this.$router.push({ name })
        }, 300)
      } else this.$router.push({ name })
    }
  },
  watch: {
    didPalletChangeFirstTime (val) {
      if (val) {
        setTimeout(() => {
          this.toggleColorPallet()
          TweenMax.from(`#tap-indicator-${this.selectedColorPallet}`, 0.4, { scale: 0, ease: Power3.easeOut })
          TweenMax.from(`#tap-indicator-${this.selectedColorPallet}`, 1, { opacity: 1, delay: 0.6 })
          this.palletChangeInterval = setInterval(() => {
            if (this.isPalletContainerVisible && this.didPalletChangeFirstTime) {
              this.toggleColorPallet()
              TweenMax.from(`#tap-indicator-${this.selectedColorPallet}`, 0.4, { scale: 0, ease: Power3.easeOut })
              TweenMax.from(`#tap-indicator-${this.selectedColorPallet}`, 1, { opacity: 1, delay: 0.6 })
            }
          }, 5000)
        }, 2000)
      }
    }
  },
  created () {
    this.$store.dispatch(this.$CHANGE_CURSOR_STATE, 'default')
  },
  mounted () {
    let colorDuration = 0.5
    this.lightColorsTl = new TimelineMax()
    this.lightColorsTl.from('#lns-light-brand', colorDuration, { scale: 0, ease: Power4.easeInOut })
      .from('#lns-light-bg', colorDuration, { scale: 0, ease: Power4.easeInOut, delay: -0.4 })
      .from('#lns-light-footer-right', colorDuration, { scale: 0, ease: Power4.easeInOut, delay: -0.4 })
      .from('#lns-light-footer-left', colorDuration, { scale: 0, ease: Power4.easeInOut, delay: -0.4 })

    this.darkColorsTl = new TimelineMax({ paused: true })
    this.darkColorsTl.from('#lns-dark-footer-left', colorDuration, { scale: 0, ease: Power4.easeInOut })
      .from('#lns-dark-footer-right', colorDuration, { scale: 0, ease: Power4.easeInOut, delay: -0.4 })
      .from('#lns-dark-bg', colorDuration, { scale: 0, ease: Power4.easeInOut, delay: -0.4 })
      .from('#lns-dark-brand', colorDuration, { scale: 0, ease: Power4.easeInOut, delay: -0.4 })

    this.$root.$on('transition-dismiss', () => { this.lenossaAnim.play() })
  }
}
</script>

<style scoped lang="sass">
  @tailwind utilities

  .ctn
    @apply font-lenossa text-white

  .logo-wrapper
    @apply relative w-full
    height: 100vh

  .content-ctn
    @apply px-3 mx-auto
    @screen md
      @apply px-5
    @screen lg
      @apply px-4
    @screen xxl
      width: 72rem

  .title
    @apply text-3xl
    @screen md
      @apply text-5xl
    @screen lg
      @apply text-6xl

  .pallet-ctn
    @apply relative

  .pallet
    $space: 30px
    $dimensions: 3.7rem
    @apply absolute z-20 pin-t flex opacity-50 pointer-events-none
    width: $dimensions * 4
    height: $dimensions
    -webkit-tap-highlight-color: transparent
    transition: opacity .5s
    &__label
      @apply absolute text-lg
      top: 50%
      right: 1.875rem
      transform: translateY(-50%)
    &__color
      @apply absolute pin-t border-3 border-white rounded-full
      width: $dimensions
      height: $dimensions
      transform: scale(0.8)
      transition: transform .5s
      @for $i from 1 through 4
        &:nth-of-type(#{$i})
          transition: transform .2s #{$i / 10}s
          left: $space * ($i - 1)
    &--active
      @apply opacity-100 pointer-events-auto
      .pallet
        &__color
          transform: scale(1)
    &--light
      div:nth-of-type(1)
        background: #009CB0
      div:nth-of-type(2)
        background: #FFD443
      div:nth-of-type(3)
        background: #CC2A34
      div:nth-of-type(4)
        background: #E75F37
    &--dark
      top: 6.25rem
      @screen sm-l
        @apply pin-t
        left: 18.75rem
      @screen md
        @apply pin-t
        left: 18.75rem
      div:nth-of-type(1)
        background: #1F2D3C
      div:nth-of-type(2)
        background: #F4E2B0
      div:nth-of-type(3)
        background: #608D66
      div:nth-of-type(4)
        background: #DE2034

  .tap-indicator
    @apply absolute half-t -translate-xy-50 rounded-full border-3 w-48 h-48 opacity-0
    left: 33%
    &--light
      @apply border-white bg-black
    &--dark
      @apply border-black bg-white

  .color-show-ctn
    @apply relative
    width: 45rem

  .lns-brand-ctn
    @apply relative w-full mt-14
    top: 10rem
    @screen sm-l
      @apply mt-12
    @screen md
      @apply mt-12
    @screen lg
      width: 48rem
      height: 12.5rem

  .brand-ctn-divider
    @apply absolute pin-l bg-white opacity-50 w-full h-px
    top: -7.25rem
    @screen sm-l
      top: -8.25rem
    @screen md
      top: -9.25rem

  .lns-footer
    @apply relative flex bg-red h-3 w-full
    top: 15.625rem
    @screen sm-l
      top: 20rem
    @screen md
      top: 23.75rem
    @screen lg
      @apply h-6
      top: 12.1875rem
    &__left
      @apply h-full
      width: 68%
      transform-origin: right center
      transition: transform .5s
    &__right
      @apply h-full
      width: 32%
      transform-origin: left center
      transition: transform .5s
    &__left.lns--light
      background: #CC2A34
    &__right.lns--light
      background: #E75F37
    &__left.lns--dark
      @apply absolute pin-l
      background: #608D66
      transform: scaleX(0)
      &.visible
        transform: scaleX(1)
    &__right.lns--dark
      @apply absolute pin-r
      background: #DE2034
      transform: scaleX(0)
      &.visible
        transform: scaleX(1)

  .lns-color
    @apply rounded-full border-3 border-white h-10 w-10
    @screen md
      @apply h-20 w-20
    @screen lg
      @apply h-24 w-24
    span
      @apply absolute text-sm
      @screen md
        @apply text-base
      @screen lg
        @apply text-lg
      right: 120%
      top: 50%
      transform: translate(0, -50%)
      @screen lg
      @apply pin-r
        left: 50%
        transform: translate(-50%, -50%)
    &--bg
      @apply absolute
      top: -76px
      left: 34%
      @screen md
        top: -100px
      @screen lg
        top: -46px
        left: 108%
    &--brand
      @apply absolute
      top: -32px
      left: 70%
      @screen md
        top: -60px
      @screen lg
        top: -100px
    &--footer-left
      @apply absolute
      top: 140%
      right: 60%
      @screen lg
        right: 40%
    &--footer-right
      @apply absolute pin-b
      right: 10%
      top: 140%
      @screen lg
        bottom: 140%
    &--brand.lns--light
      background: #FFD443
    &--brand.lns--dark
      background: #F4E2B0
    &--footer-left.lns--light
      background: #CC2A34
    &--footer-right.lns--light
      background: #E75F37
    &--footer-right.lns--dark
      background: #DE2034
    &--footer-left.lns--dark
      background: #608D66

  .photos-section
    @apply relative
    top: 25rem
    @screen md
      top: 31.25rem
    @screen lg
      top: 25rem

  .logo
    @apply absolute pin-t pin-l
    transition: opacity .5s

  .photo
    @apply block mx-auto shadow-lg
    &--smartphone
      width: 40rem

  .footer-page-ctn
    @apply relative
    top: 500px

  .footer-btns-ctn
    @apply flex flex-col items-center justify-center mt-4 mb-3
    @screen sm-l
      @apply flex-row mt-0
    @screen md
      @apply flex-row

  .lns-btn
    @apply relative
    &__body
      @apply relative z-20 text-white text-lg rounded-lg px-2 py-1
      cursor: none
      background: #e1b83a
      transition: transform .5s
    &__icon
      @apply absolute z-10 text-lg text-white
      top: 50%
      transition: all .4s
      transform: translate(0, -50%)
    &--left
      .lns-btn
        &__icon
          left: 15px
        &__body
          &:hover
            transform: translateX(-10px)
            & + i
              transform: translate(-50px, -50%)
    &--right
      .lns-btn
        &__icon
          @apply text-3xl
          right: 15px
        &__body
          &:hover
            transform: translateX(10px)
            & + i
              transform: translate(60px, -50%)

  .lns-page-footer
    @apply relative overflow-hidden h-28
    @screen sm-l
      @apply h-48
    @screen md
      @apply h-48
    @screen xl
      @apply h-64
    @screen xxl
      @apply h-96
    &__img
      @apply absolute half-l -translate-x-50 h-full
      width: 110%
      background-size: cover
      background-repeat: no-repeat
      top: 23%
      @screen sm-l
        top: 10%
      @screen md
        top: 10%
      @screen xxl
        width: 105%
      &--light
        background-image: url("~@/assets/lenossa/lenossa-footer-light.svg")
      &--dark
        background-image: url("~@/assets/lenossa/lenossa-footer-dark.svg")

  .page-lns-dark-bg
    @apply fixed z-10 pin-t pin-l pointer-events-none w-full
    height: 120vh
    transition: opacity .5s
    background: #1F2D3C

  .page-lns-light-bg
    @apply fixed pin-t pin-l pointer-events-none w-full
    height: 120vh
    background: #009CB0
</style>
